// Auth Callback Component - Handles OAuth redirect
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      if (!hash || !hash.includes('session_id=')) {
        console.error('No session_id found in URL');
        navigate('/proview/login', { replace: true });
        return;
      }

      const sessionId = hash.split('session_id=')[1]?.split('&')[0];
      if (!sessionId) {
        console.error('Could not parse session_id');
        navigate('/proview/login', { replace: true });
        return;
      }

      // Exchange session_id for user data
      const result = await exchangeSession(sessionId);

      if (result.success) {
        // Clear the hash and redirect to dashboard
        navigate('/proview/dashboard', { replace: true });
      } else {
        console.error('Auth failed:', result.error);
        navigate('/proview/login', { replace: true, state: { error: result.error } });
      }
    };

    processAuth();
  }, [exchangeSession, location.hash, navigate]);

  return (
    <div className="min-h-screen bg-[#1E1E1E] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#F7A600] animate-spin mx-auto mb-4" />
        <p className="text-white text-lg">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
